module.exports = __webpack_public_path__ + "static/wireframes-3-ebd82ab1dea399dd1217886e5e8c955b.jpg";